"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaterToVenus = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var WaterToVenus = (function (_super) {
    __extends(WaterToVenus, _super);
    function WaterToVenus() {
        return _super.call(this, {
            name: CardName_1.CardName.WATER_TO_VENUS,
            cardType: CardType_1.CardType.EVENT,
            tags: [Tags_1.Tags.SPACE],
            cost: 9,
            tr: { venus: 1 },
            metadata: {
                cardNumber: '254',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) { return b.venus(1); }),
                description: 'Raise Venus 1 step.',
            },
        }) || this;
    }
    ;
    WaterToVenus.prototype.play = function (player) {
        player.game.increaseVenusScaleLevel(player, 1);
        return undefined;
    };
    return WaterToVenus;
}(Card_1.Card));
exports.WaterToVenus = WaterToVenus;
